/**
 * The texts of the public site in the base language (Hungarian), for the case when the translations of the server
 * could not be loaded: the page is shown with them instead of staying empty. They are used only then, the
 * translations of the server always win, so the page looks the same as before when everything works.
 */
export const FALLBACK_TRANSLATIONS: Record<string, string> = {
	'general-search': 'Keresés',
	'news-more': 'További hírek',
	'alert-error-title': 'Hiba történt!',
	'alert-error-text': 'Valami hiba történt!',
	'ops-error-title': 'Hiba történt!',
	'ops-error-text': 'Valami hiba történt!',
	'success-save-title': 'Sikeres mentés!',
	'success-save-text': 'Az adatok mentése sikerült.',
	'general-loader-title': 'Betöltés...',
};
